'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorFormatAlignRight = function EditorFormatAlignRight(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 21h18v-2H3v2zm6-4h12v-2H9v2zm-6-4h18v-2H3v2zm6-4h12V7H9v2zM3 3v2h18V3H3z' })
  );
};
EditorFormatAlignRight = (0, _pure2.default)(EditorFormatAlignRight);
EditorFormatAlignRight.displayName = 'EditorFormatAlignRight';
EditorFormatAlignRight.muiName = 'SvgIcon';

exports.default = EditorFormatAlignRight;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/editor/format-align-right.js
 ** module id = 1909
 ** module chunks = 0
 **/